// Imported first by main.tsx, before any schema is made. Zod compiles object parsers with
// `new Function` unless told not to, and the Content Security Policy (ADR 0037) forbids eval:
// even its probe for whether eval works is reported as a violation.
import { z } from 'zod';

z.config({ jitless: true });
